import { Injectable } from '@angular/core';
import {
  AlertController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { CustomAlertComponent } from 'src/app/components/custom-alert/custom-alert.component';
import { ModalSheetAlertComponent } from 'src/app/components/modal-sheet-alert/modal-sheet-alert.component';
import { AlertOptions } from 'src/app/interfaces/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController
  ) {}

  async alertSuccess(message) {
    const alert = await this.alertCtrl.create({
      header: 'Success',
      message: message,
      animated: true,
      cssClass: 'success-alert',
      buttons: ['Ok'],
    });

    await alert.present();
  }

  async alertError(message) {
    const alert = await this.alertCtrl.create({
      header: 'Error',
      message: message,
      animated: true,
      cssClass: 'error-alert',
      buttons: ['Ok'],
    });

    await alert.present();
  }

  async alertWarning(message) {
    const alert = await this.alertCtrl.create({
      header: 'Warning',
      message: message,
      animated: true,
      cssClass: 'warning-alert',
      buttons: ['Ok'],
    });

    await alert.present();
  }

  async alertInfo(message) {
    const alert = await this.alertCtrl.create({
      header: 'Info',
      message: message,
      animated: true,
      cssClass: 'info-alert',
      buttons: ['Ok'],
    });

    await alert.present();
  }

  async toastSuccess(message) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
      cssClass: 'toast-success',
    });

    await toast.present();
  }

  async toastWarning(message) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
      cssClass: 'toast-warning',
    });

    await toast.present();
  }

  async toastInfo(message) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
      cssClass: 'toast-info',
    });

    await toast.present();
  }

  async toastError(message) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
      cssClass: 'toast-error',
    });

    await toast.present();
  }

  async showToast(message, position) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 2000,
      position: position,
    });

    await toast.present();
  }

  async showAlert(header, message) {
    const alert = await this.alertCtrl.create({
      header: header,
      message: message,
      animated: true,
      cssClass: 'custom-alert',
      buttons: ['Ok'],
    });

    await alert.present();
  }


  async customAlert(status, message, isClipboard = false, clipboardValue= '', clipboardDesc = '') {
    const modal = await this.modalCtrl.create({
      component: CustomAlertComponent,
      componentProps: {
        status : status,
        message : message,
        isClipboard : isClipboard,
        clipboardValue : clipboardValue,
        clipboardDesc : clipboardDesc
      },
      canDismiss: true,
      cssClass: 'fit-content-modal'
    });

    await modal.present();
  }

  async showSheetAlert(opts: AlertOptions) {
    const modal = await this.modalCtrl.create({
      component: ModalSheetAlertComponent,
      componentProps: opts,
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-sheet-auto-height',
      mode: 'ios',
      handle: false,
      backdropDismiss: false,
    });

    await modal.present();
  }
}
